import { prop } from 'ramda';
import React, { memo, useCallback } from 'react';
import Overlay from 'js/components/common/Overlay';
import { useSubscribeOnLocationChange } from 'js/hooks/useSubscribeOnLocationChange';

import { Content } from './components/Content';
import * as actions from '../../../../store/actions';
import { useDynamicReducerSelector, useDynamicReducerDispatch } from '../../../../store';

import style from './GamesFiltersPopup.scss';

export const GamesFiltersPopupBare: React.FC = () => {
    const dispatch = useDynamicReducerDispatch();
    const isFiltersPopupOpened = useDynamicReducerSelector(prop('isFiltersPopupOpened'));
    const isOpenedClass = isFiltersPopupOpened ? style.opened : '';

    const handlePopupClose = useCallback(() => {
        dispatch(actions.toggleFilterPopup(false));
    }, [dispatch]);

    useSubscribeOnLocationChange(handlePopupClose);

    return (
        <>
            <div className={`${style.popup} ${isOpenedClass} cms-games-grid-mobile-filters-popup`}>
                {isFiltersPopupOpened && (
                    <Content />
                )}
            </div>
            {isFiltersPopupOpened && (
                <Overlay
                    className={style.overlay}
                    onClick={handlePopupClose}
                />
            )}
        </>
    );
};

export const GamesFiltersPopup = memo(GamesFiltersPopupBare);
